import { useEffect } from "react";
import "./ConfirmSendBackModal.css";

const ConfirmSendBackModal = ({
  open,
  candidateName = "",
  onClose,
  onConfirm,
}) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const nameLabel = candidateName || "the candidate";

  return (
    <div
      className="rr-confirm-modal-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="rr-confirm-modal rr-confirm-modal--send-back"
        role="dialog"
        aria-modal="true"
        aria-labelledby="rr-confirm-send-back-title"
        aria-describedby="rr-confirm-send-back-desc"
        onClick={(event) => event.stopPropagation()}
      >
        <div
          className="rr-confirm-modal__icon-wrap rr-confirm-modal__icon-wrap--send-back"
          aria-hidden="true"
        >
          <span className="material-symbols-rounded rr-confirm-modal__icon rr-confirm-modal__icon--send-back">
            front_hand
          </span>
        </div>

        <h2
          id="rr-confirm-send-back-title"
          className="rr-confirm-modal__title"
        >
          Send this back to {nameLabel}?
        </h2>

        <p
          id="rr-confirm-send-back-desc"
          className="rr-confirm-modal__desc"
        >
          They&apos;ll get an email with the flagged items and a chance to fix
          them up. It lands back in your queue once they resubmit. Take a last
          look before you confirm.
        </p>

        <div className="rr-confirm-modal__actions">
          <button
            type="button"
            className="btn p-btn p-btn-blk rr-confirm-modal__btn"
            onClick={onClose}
          >
            <div className="p-btn-text">Let me double-check</div>
          </button>
          <button
            type="button"
            className="btn p-btn p-btn-og rr-confirm-modal__btn"
            onClick={onConfirm}
          >
            <div className="p-btn-text">Yes, flag to candidate</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSendBackModal;
